module.exports = __webpack_public_path__ + "media/images/front/products/standard/product_2-5680dbbb38f06546673d43426c49785c.jpg";